import { render, staticRenderFns } from "./zxksks.vue?vue&type=template&id=710f75c0&scoped=true&"
import script from "./zxksks.vue?vue&type=script&lang=js&"
export * from "./zxksks.vue?vue&type=script&lang=js&"
import style0 from "./zxksks.vue?vue&type=style&index=0&id=710f75c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f75c0",
  null
  
)

export default component.exports